$(document).on('click','a',function(){
	var url = $(this).attr('href');
	if(typeof ga === "function")
	{
		if(url && !url.match(BASEPATH))
		{
			if(url.match('facebook.com'))
				ga('send', 'event', 'click-external-link', 'click-EL-social-network', 'click-EL-SN-facebook');
			else if(url.match('pinterest'))
				ga('send', 'event', 'click-external-link', 'click-EL-social-network', 'click-EL-SN-pinterest');
			else if(url.match('linkedin'))
				ga('send', 'event', 'click-external-link', 'click-EL-social-network', 'click-EL-SN-linkedin');
			else if(url.match('instagram'))
				ga('send', 'event', 'click-external-link', 'click-EL-social-network', 'click-EL-SN-instagram');
			else if(url.match('twitter'))
				ga('send', 'event', 'click-external-link', 'click-EL-social-network', 'click-EL-SN-twitter');
			else
				ga('send', 'event', 'click-external-link', 'click-EL-unknown', 'click-EL-unknown');
		}
	}
})


function extra_analytics_init() {
	var linkerParam = (function() {
		try {
			var trackers = ga.getAll();
			var i, len;
			for (i = 0, len = trackers.length; i < len; i += 1) {
				if (trackers.length==1 || trackers[i].get('trackingId') === ENV_GOOGLE_UAC) {
					return trackers[i].get('linkerParam');
				}
			}
		} catch(e) {}
		return false;
	})();
	if(linkerParam===false)
		linkerParam = '';

	if(linkerParam)
		$.post(BASEPATH+'api/ga_storage',{linkerParam:linkerParam});
}

if (document.readyState != 'loading'){
	extra_analytics_init();
} else {
	document.addEventListener('DOMContentLoaded', extra_analytics_init);
}




